import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './jobCatalogues.intl.json';

export const useJobCataloguesIntl = () => useIntlModule(messages);
